"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrganisationRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.CreateOrganisationRequestStruct = (0, superstruct_1.type)({
    name: (0, superstruct_1.string)(),
    imageStoragePath: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    streetAddress: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    postalCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    referralCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    city: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    country: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    vatId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    industry: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=CreateOrganisationRequest.js.map